import { CustomerType } from "@origin-digital/platform-enums";
import { CommonParameters, IMcAppType, NavFlow, Tab } from "../mcApp.types";

const { customerNumber } = CommonParameters;

export const lpgPaymentSettingsMethod: IMcAppType = {
  name: "lpgPaymentSettingsMethod",
  path: "/my/payment-settings/lpg/method",
  parameters: {
    properties: { customerNumber },
  },
  description: "Payment method for a set of given customer numbers",
  navFlow: NavFlow.FOCUS,
  title: "Payment method",
  parent: Tab.MORE,

  conditions: {
    intent: "lpgPaymentSettingsMethod",
    customerType: CustomerType.kraken,
  },
};
